import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import toast from 'react-hot-toast';
import useLoginHandler from '../hook';
import styles from './LoginForm.module.css';
import VerifyEmail from './VerifyEmail';

const LoginForm = () => {
  const [data, setData] = useState({
    password: '',
    email: '',
    role: 'admin'
  });
  const [privacyPolicyCheck, setPrivacyPolicyCheck] = useState(true);
  const [passwordFlow, setPasswordFlow] = useState(false);
  const [showVerifyEmail, setShowVerifyEmail] = useState(false);

  const loginAdminController = useLoginHandler();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (privacyPolicyCheck && data.email !== '' && data.password !== '') {
      loginAdminController(data);
    }
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const handlePrivacyPolicyCheck = (e) => {
    setPrivacyPolicyCheck((p) => !p);
  };

  const handleForgotPasswordBtn = () => {
    // if (!privacyPolicyCheck) {
    //   toast.error('Please check the terms and privacy policy');
    //   return false;
    // }
    setPasswordFlow(true);
    setShowVerifyEmail((p) => !p);
  };

  return (
    <div className={styles['login-form__input']}>
      {showVerifyEmail ? (
        <VerifyEmail
          passwordFlow={passwordFlow}
          setPasswordFlow={setPasswordFlow}
          setShowVerifyEmail={setShowVerifyEmail}
        />
      ) : (
        <>
          <form id={styles['login-form']} onSubmit={handleSubmit}>
            <input
              required
              type="email"
              name="email"
              onChange={handleChange}
              value={data.email}
              className={styles['login-form__input']}
              placeholder="Email Address"
            />
            <input
              required
              type="password"
              name="password"
              onChange={handleChange}
              value={data.password}
              className={styles['login-form__input']}
              placeholder="Password"
            />
            <input
              type="submit"
              value="Login"
              disabled={data.email === '' || data.password === '' || !privacyPolicyCheck}
              id={styles['login-form__submit']}
            />
            <div className={styles['create-account']}>
              <p>
                new to Fewcents?<Link to="/register">Create Account</Link>
              </p>
              <input
                type="button"
                onClick={handleForgotPasswordBtn}
                value="Forgot Password"
                id={styles['button-link']}
              />
            </div>
            <div className={styles['privacy-policy']}>
              <input
                type="checkbox"
                checked={privacyPolicyCheck}
                onChange={handlePrivacyPolicyCheck}
                value={privacyPolicyCheck}
              />
              <p>
                I agree to Fewcents{' '}
                <a href="https://fewcents.co/terms" target="_blank" rel="noreferrer">
                  Terms
                </a>{' '}
                and{' '}
                <a href="https://fewcents.co/privacy" target="_blank" rel="noreferrer">
                  Privacy Policy
                </a>
                . I consent to my data being processed outside EU.
              </p>
            </div>
          </form>
        </>
      )}
    </div>
  );
};

export default LoginForm;
